import React from 'react';
import AHref from "../../ahref/ahref";
import Icon from '../../icons/icon/icon';
import { IconProps } from '../../icons/icon-props-interface';
import './button-icon.scss';

export interface IButtonProps extends IconProps {
	onClick?: () => void;
	Component: React.FC<IconProps>;
    href?: string;
    target?: React.HTMLAttributeAnchorTarget;
	disabled?: boolean;
	comingSoon?: boolean;
}

export const ButtonIcon: React.FC<IButtonProps> = ({ Component, onClick = () => {}, disabled = false, comingSoon = false, color = undefined, href, target = '_self' }) => {
    const handleClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        if (!href) {
            e.preventDefault();
        }
        onClick();
    }
	
    const button = (
		<button className={`icon-button`} onClick={handleClick}disabled={disabled}>
			<Icon Component={Component} disabled={disabled} color={color} comingSoon={comingSoon}/>
		</button>
	);

    if(href) {
        return (<AHref href={href} target={target}>{button}</AHref>)
    }
    return (
        <>
            {button}
        </>
            );
}